import { render } from "./CreacionUsuariosView.vue?vue&type=template&id=a67f2d12"
import script from "./CreacionUsuariosView.vue?vue&type=script&lang=js"
export * from "./CreacionUsuariosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__